import YouTubePlayer from 'youtube-player'
import { bus } from '@/consts'

export default {
  name: 'VideoPlayer',
  template: '#video-player-template',
  data () {
    return {
      ytPlayer: null
    }
  },
  props: ['id', 'ytVidId'],
  computed: {
    elementId () {
      return this.$refs.vidEl.getAttribute('id')
    }
  },
  methods: {
    createVideoPlayer () {
      this.ytPlayer = YouTubePlayer(this.elementId, {
        'width': '1024',
        'height': '576',
        'playerVars': {
          'autoplay': 1,
          'modestbranding': 1,
          'rel': 0,
          'showInfo': 0
        }
      })
      this.ytPlayer.on('stateChange', (event) => {
        if (event.data === 0) {
          bus.$emit('hero-video-end')
        }
      })
      this.ytPlayer.loadVideoById(this.ytVidId)
    }
  },
  mounted () {
    this.createVideoPlayer()
  },
  beforeDestroy () {
    this.ytPlayer.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/components/VideoPlayer.js